/**
 * Pega duas coordenadas e mostra informações do percurso entre elas, velocidade média
 * tempo gasto, distância percorrida.
 *
 * @author Daniel Laurindo
 * Date: 26/02/2012
 * Time: 09:05
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 11:00
 */

import { actionCreators } from "react/api/actions/alerts";

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.Points = Greenmile.Toolbar.Map.Points || {};

Greenmile.Toolbar.Map.Points = function (selector, map) {

    this.polyline = null;
    this.addListeners = () => {
        $(selector + " .dropdownMeasurement .Pointsdistance").off("click");
        $(selector + " .dropdownMeasurement .Pointsdistance").on("click", (event) => {
            if (this.polyline) {
                this.polyline.disable();
            }

            const div = document.querySelector(selector.replace('#mapCon', '') + ".leaflet-draw-label.freeMeasurement");
            if (!div) {
                this.polyline = new L.Polyline.Draw(map);
                this.polyline.enable();
                this.polyline._updateLabelPosition(map.latLngToLayerPoint(map.mouseEventToLatLng(event)));
            }
            map.on('zoomend', this._onZoomChange, this);

            window.globalStore.dispatch(actionCreators.closeAlert({ key: 'trackEquipmentCoords' }));
            window.globalStore.dispatch(actionCreators.closeAlert({ key: 'routeDetailsCoords' }));
        });
    };

    this._onZoomChange = (e) => {
        if(!this.polyline || !this.polyline._markers) return;
        const markerCount = this.polyline._markers.length;
        if (markerCount > 0) {
            this.polyline._clearGuides();
            this.polyline._drawGuide(
                map.latLngToLayerPoint(this.polyline._markers[markerCount - 1].getLatLng()),
                map.latLngToLayerPoint(this.polyline._currentLatLng)
            );
        }
    };
};
